<template
  ><tsny-modal
    :modal-id="modalId"
    :modal-title="'Delete Score Report'"
    :submit-button-text="'DELETE'"
    :reset-modal="resetModal"
    :submit-modal="deleteScoreReport"
  >
    <b-row>
      <b-col>
        <div class="tsny_text">
          This will delete the selected score report. Please be absolutely
          certain you wish to do this as this action cannot be undone.
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="tsny_status-text" v-if="deleteScoreReportError">
          An error occurred deleting your score report.
        </div>
      </b-col>
    </b-row>
  </tsny-modal></template
>

<script>
import TsnyModal from "../TsnyModal";
import ExamRestService from "../../services/rest/services/ExamRestService";
import StoreConstants from "../../store/services/StoreConstants";
import { mapActions } from "vuex";
export default {
  name: "DeleteScoreReportModal",
  components: { TsnyModal },
  props: {
    relationshipId: {
      type: String,
      default: null
    },
    reportId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    modalId: "deleteScoreReportModal",
    deleteScoreReportError: false
  }),
  methods: {
    ...mapActions({
      vuexDelete: StoreConstants.ACTIONS.DELETE_SCORE_REPORT
    }),
    resetModal() {
      this.deleteScoreReportError = false;
    },
    async deleteScoreReport(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this;
      $comp.deleteScoreReportError = false;

      try {
        await ExamRestService.deleteScoreReport({
          relationshipId: this.relationshipId,
          reportId: this.reportId
        });
        $comp.vuexDelete({
          relationshipId: this.relationshipId,
          reportId: this.reportId
        });
        $comp.$bvModal.hide($comp.modalId);
      } catch (error) {
        console.log(error);
        $comp.deleteScoreReportError = true;
      }
    }
  }
};
</script>

<style scoped></style>
